import AllIcon from 'components/Resources/images/Blue/All.svg';
import GrayAllIcon from 'components/Resources/images/Black/All.svg';
import AppICon from 'components/Resources/images/Blue/Apps.svg';
import GrayAppIcon from 'components/Resources/images/Black/Apps.svg';
import BookIcon from 'components/Resources/images/Blue/Books.svg';
import GrayBookIcon from 'components/Resources/images/Black/Books.svg';
import ReadIcon from 'components/Resources/images/Blue/Articles.svg';
import GrayReadIcon from 'components/Resources/images/Black/Articles.svg';
import PodcastIcon from 'components/Resources/images/Blue/Podcasts.svg';
import GrayPodcastIcon from 'components/Resources/images/Black/Podcasts.svg';
import VideoIcon from 'components/Resources/images/Blue/Videos.svg';
import GrayVideoIcon from 'components/Resources/images/Black/Videos.svg';
import OrganizationIcon from 'components/Resources/images/Blue/Organizations.svg';
import GrayOrgsIcon from 'components/Resources/images/Black/Organizations.svg';
import NewsIcon from 'components/Resources/images/Blue/News.svg';
import GrayNewsIcon from 'components/Resources/images/Black/News.svg';
import FAQIcon from 'components/Resources/images/Blue/FAQ.svg';
import GrayFAQIcon from 'components/Resources/images/Black/FAQ.svg';
import ProgramsIcon from 'components/Resources/images/Blue/Programs.svg';
import GrayProgramsIcon from 'components/Resources/images/Black/Programs.svg';
export const MEDIA_TYPES = [
  {
    label: 'All Media Types',
    value: 'All Media Types',
    icons: [AllIcon, GrayAllIcon],
  },
  {
    label: 'Apps',
    value: 'Apps',
    icons: [AppICon, GrayAppIcon],
  },
  {
    label: 'Podcasts',
    value: 'Podcasts',
    icons: [PodcastIcon, GrayPodcastIcon],
  },
  {
    label: 'Videos',
    value: 'Videos',
    icons: [VideoIcon, GrayVideoIcon],
  },
  {
    label: 'Articles',
    value: 'Articles',
    icons: [ReadIcon, GrayReadIcon],
  },
  {
    label: 'Books',
    value: 'Books',
    icons: [BookIcon, GrayBookIcon],
  },
  {
    label: 'News',
    value: 'News',
    icons: [NewsIcon, GrayNewsIcon],
  },
  {
    label: 'FAQ',
    value: 'FAQ',
    icons: [FAQIcon, GrayFAQIcon],
  },
  {
    label: 'Online Programs',
    value: 'Online Programs',
    icons: [ProgramsIcon, GrayProgramsIcon],
  },
  {
    label: 'Organizations',
    value: 'Organizations',
    icons: [OrganizationIcon, GrayOrgsIcon],
  },
];

export const ALL_APPROACHES = {
  label: 'All Approaches',
  value: 'ALL',
};

export const typesIcons = {
  Apps: [AppICon, GrayAppIcon],
  Podcasts: [PodcastIcon, GrayPodcastIcon],
  Videos: [VideoIcon, GrayVideoIcon],
  Articles: [ReadIcon, GrayReadIcon],
  Books: [BookIcon, GrayBookIcon],
  News: [NewsIcon, GrayNewsIcon],
  FAQ: [FAQIcon, GrayFAQIcon],
  Organizations: [OrganizationIcon, GrayOrgsIcon],
  'Online Programs': [ProgramsIcon, GrayProgramsIcon],
};
